<div class="container">
  <div class="row">
<!--    <mat-form-field appearance="outline" class="col-3 ms-3">-->
<!--      <mat-label>Centres</mat-label>-->
<!--      <mat-select [(ngModel)]="selectedCentres" multiple>-->
<!--        <mat-option *ngFor="let c of centres | async" [value]="c.centreCode">-->
<!--          {{ c.centreCode }}-->
<!--        </mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

    <mat-form-field appearance="outline" class="col-3 ms-3">
      <mat-label>Select Centres</mat-label>

      <mat-select [(ngModel)]="selectedCentres" multiple>

        <mat-select-trigger>
          <ng-container *ngIf="selectedCentres.length === 0">
            Select Centres
          </ng-container>

          <ng-container *ngIf="selectedCentres.length > 0 && selectedCentres.length <= 1">
            {{ selectedCentres.join(', ') }}
          </ng-container>

          <ng-container *ngIf="selectedCentres.length > 1">
            {{ selectedCentres.slice(0, 1).join(', ') }}
            <span class="more-orange"> + {{ selectedCentres.length - 1 }} more</span>
          </ng-container>
        </mat-select-trigger>


        <mat-option *ngFor="let c of centres | async" [value]="c.centreCode">
          {{ c.centreCode }}
        </mat-option>

      </mat-select>
    </mat-form-field>


    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Select Date Range</mat-label>
      <mat-date-range-input [rangePicker]="picker" (selectionchange)="onRangeChange($event)">
        <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
        <input matEndDate [(ngModel)]="endDate" placeholder="End date">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <div class="col-1 d-flex gap-2">
      <button mat-mini-fab color="accent" (click)="mSearch()">
        <mat-icon> search</mat-icon>
      </button>
      <button mat-mini-fab color="accent" (click)="clearAll()">
        <mat-icon> clear</mat-icon>
      </button>
    </div>
  </div>
  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Daily Inventory Count</h2>
      </li>
      <li class="dropdown m-l-20">
        <label for="search-input"><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" type="text" class="browser-default search-field"
               (keyup)='applyFilter($event)' aria-label="Search box" #input>
      </li>
    </ul>
  </div>
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z2">
      <ng-container matColumnDef="sr">
        <th mat-header-cell *matHeaderCellDef> Sr.No</th>
        <td mat-cell *matCellDef="let row; let i=index"> {{ i + 1 }}</td>
      </ng-container>
      <ng-container matColumnDef="centreCode">
        <th mat-header-cell *matHeaderCellDef> Centre Name</th>
        <td mat-cell *matCellDef="let row"> {{ row.centreCode }}</td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef> Date</th>
        <td mat-cell *matCellDef="let row"> {{ row.date }}</td>
      </ng-container>

      <ng-container matColumnDef="productName">
        <th mat-header-cell *matHeaderCellDef> Product</th>
        <td mat-cell *matCellDef="let row"> {{ row.productName }}</td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef> Avl.Qty</th>
        <td mat-cell *matCellDef="let row"> {{ row.quantity | number:'1.2-2' }}</td>
      </ng-container>
      <ng-container matColumnDef="openingStock">
        <th mat-header-cell *matHeaderCellDef>
          Opening <br>({{ startDate | date:'dd-MM-yyyy' }})
        </th>
        <td mat-cell *matCellDef="let row"> {{ row.openingStock }}</td>
      </ng-container>

      <ng-container matColumnDef="closingStock">
        <th mat-header-cell *matHeaderCellDef>
          Closing <br>({{ endDate | date:'dd-MM-yyyy' }})
        </th>
        <td mat-cell *matCellDef="let row"> {{ row.closingStock }}</td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
    </table>
    <div *ngIf="noDataFound && !isLoading" class="no-data-box">
      <p>No data found for selected centre(s) and date range.</p>
    </div>

    <mat-paginator
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 25, 100]"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="60"></mat-spinner>
</div>
